<proffeo-ui-dialog [title]="'project-tasks.export.confirmation-title' | translate">
  <div class="flex flex-col gap-4">
    <p class="text-base">
      {{ 'project-tasks.export.confirmation-description' | translate }}
    </p>
    <mat-checkbox
      (change)="setIncludeSubtasks($event.checked)"
      [checked]="includeSubtasks()"
    >
      {{ 'project-tasks.export.include-subtasks' | translate }}
    </mat-checkbox>
  </div>
  <div
    dialog-actions
    class="flex w-full justify-end gap-2"
  >
    <proffeo-ui-button
      (clicked)="cancel()"
      variant="primary"
      text="modals.confirmation-modal-cancel"
    ></proffeo-ui-button>
    <proffeo-ui-button
      (clicked)="confirmExport()"
      variant="accent"
      text="project-tasks.export.confirm"
    ></proffeo-ui-button>
  </div>
</proffeo-ui-dialog>
